var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4517_288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 8.4375H3.16406V3.89545C3.78323 3.528 4.21875 2.88162 4.21875 2.10938C4.21875 0.944367 3.27438 0 2.10938 0C0.944367 0 0 0.944367 0 2.10938C0 2.88162 0.435516 3.528 1.05469 3.89545V8.4375H0V36H4.21875V8.4375Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 2.10938C36 0.944367 35.0556 0 33.8906 0C32.7256 0 31.7812 0.944367 31.7812 2.10938C31.7812 2.88162 32.2168 3.528 32.8359 3.89545V8.4375H31.7812V36H36V8.4375H34.9453V3.89545C35.5645 3.528 36 2.88162 36 2.10938Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6719 29.008L19.0547 24.7891V29.3321L29.6719 33.5513V29.008Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6719 12.5018C28.6003 12.2011 27.5517 11.4937 26.5312 10.7498C25.046 9.66523 23.361 8.4375 21.1641 8.4375H19.0547V22.5158L29.6719 26.7346V12.5018Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 8.4375H14.8359C12.639 8.4375 10.8837 9.66523 9.39846 10.7498C8.37802 11.4937 7.39969 12.2011 6.32812 12.5018V26.7343L16.9453 22.5153V8.4375Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 24.7891L6.32812 29.008V33.5518L16.9453 29.3326V24.7891Z",
    fill: "#D2AE5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4517_288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledSeven);
export default __webpack_public_path__ + "static/media/al-filled-seven.31614d95b9a600efbc3ccf844f6b8086.svg";
export { ForwardRef as ReactComponent };